import AccountMarketingMaterialWeddingFlyerVideoGuestbookTemplate from './AccountMarketingMaterialWeddingFlyerVideoGuestbookTemplate';

export default AccountMarketingMaterialWeddingFlyerVideoGuestbookTemplate;
